'use client';

import cx from 'classnames';

import { Column, Grid } from '~/ui/components/grid';
import { Breakpoint } from '~/ui/styles/grid';
import truncateStyles from '~/ui/styles/truncate.module.scss';
import typographyStyles from '~/ui/styles/typography.module.scss';

import styles from './suggestions.module.scss';

export interface SuggestionsProps extends React.ComponentPropsWithoutRef<'div'> {
  label: string;
  suggestions: { title: string; href: string }[];
  fullWidth?: boolean;
}

export function Suggestions({
  className,
  label,
  suggestions,
  fullWidth,
  ...props
}: SuggestionsProps): React.ReactElement {
  return (
    <Grid fullWidth={fullWidth}>
      <Column
        span={{
          [Breakpoint.MOBILE]: fullWidth ? 7 : 5,
          [Breakpoint.TABLET]: fullWidth ? 9 : 7,
          [Breakpoint.DESKTOP]: fullWidth ? 9 : 7,
        }}
        offsetLeft={{
          ...(!fullWidth && { [Breakpoint.DESKTOP]: 1 }),
        }}
      >
        <div className={className} {...props} aria-live="polite">
          <p className={cx(styles.label, typographyStyles.bodySmall)}>{label}</p>
          <ul className={styles.list}>
            {suggestions.map((suggestion, index) => (
              <li className={typographyStyles.bodyLarge} key={index}>
                <a className={cx(styles.link, truncateStyles.truncate1)} href={suggestion.href}>
                  {suggestion.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </Column>
    </Grid>
  );
}
